<template lang="pug">
div(:class="$vuetify.breakpoint.mobile ? 'pa-0' : 'pa-8'")
  div(:class="$vuetify.breakpoint.mobile ? 'd-flex align-center flex-nowrap overflow-x-auto gap-2 mb-4' : ''")
    range-dropdown-mobile(v-if="dates && $vuetify.breakpoint.mobile")
    div.d-flex.align-center.gap-2(:class="$vuetify.breakpoint.mobile ? '' : 'mb-6'")
      template(v-if="!$vuetify.breakpoint.mobile")
        div.text-3xl.font-semibold Inventory
        v-spacer
      company-dropdown(v-if="isHq")
      provider-dropdown.mr-2
      range-dropdown(v-if="dates && !$vuetify.breakpoint.mobile")

  v-row(v-if="dates" :no-gutters="$vuetify.breakpoint.mobile")
    v-col(cols="12" sm="6" :class="[{ 'mb-2':$vuetify.breakpoint.mobile }]")
      stat-card(title="Low stock items" :value="trends.low_stock_items || 0" :suffix="trends.low_stock_items > 1 ? 'items low in stock' : 'item low in stock'" :loading="isFetchingTrends")
    v-col(cols="12" sm="6" :class="[{ 'mb-6':$vuetify.breakpoint.mobile }]")
      stat-card(title="Expiring items" :value="trends.expiring_items || 0" :suffix="trends.expiring_items > 1 ? 'items expiring' : 'item expiring'" :loading="isFetchingTrends")
    v-col(cols="12" sm="4" :class="[{ 'mb-2':$vuetify.breakpoint.mobile }]")
      stat-card(title="Value of sitting inventory" :value="trends.sitting_value | displayPriceNoCent" :loading="isFetchingTrends")
    v-col(cols="12" sm="4" :class="[{ 'mb-2':$vuetify.breakpoint.mobile }]")
      stat-card(title="Leakage/wastage" :value="trends.leakage_value | displayPriceNoCent" :loading="isFetchingTrends")
    v-col(cols="12" sm="4" :class="[{ 'mb-6':$vuetify.breakpoint.mobile }]")
      stat-card(title="Cost of inventory sold" :value="trends.sold_value | displayPriceNoCent" :loading="isFetchingTrends")
    v-col(cols="12" sm="6" :class="[{ 'mb-6':$vuetify.breakpoint.mobile }]")
      ranking-card(type="services" :providers="selectedProviders" :begin="beginDate" :until="untilDate")
    v-col(cols="12" sm="6")
      ranking-card(type="medication" :providers="selectedProviders" :begin="beginDate" :until="untilDate")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { DateTime } from 'luxon'
import RangeDropdown from './RangeDropdown.vue'
import RangeDropdownMobile from './RangeDropdownMobile.vue'
import ProviderDropdown from './ProviderDropdown.vue'
import StatCard from './StatCard.vue'
import RankingCard from './RankingCard.vue'
import CompanyDropdown from '@/components/hq/custom/CompanyDropdown.vue'

export default {
  name: 'InsightInventory',
  components: { RangeDropdown, RangeDropdownMobile, ProviderDropdown, StatCard, RankingCard, CompanyDropdown },
  data: () => ({
    isFetchingTrends: true,
    trends: {},
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      dates: 'insight/getDates',
      beginDate: 'insight/getBeginDate',
      untilDate: 'insight/getUntilDate',
      selectedProviders: 'insight/getSelectedProviders',
      selectedCompanies: 'insight/getSelectedCompanies',
      currentDateRange: 'insight/getCurrentDateRange',
      isHq: 'hq/getIsHq'
    }),
  },
  watch: {
    dates () {
      this.fetchTrends()
    },
    selectedProviders: {
      handler() {
        this.fetchTrends()
      },
      deep: true
    },
    selectedCompanies: {
      handler() {
        this.fetchTrends()
      },
      deep: true
    }
  },
  created () {
    this.setupDates()
  },
  methods: {
    ...mapActions(['showMessage']),
    setupDates () {
      if (this.dates) {
        this.fetchTrends()
        return
      }
      const now = DateTime.local()
      const dateFormat = 'yyyy-MM-dd'
      const yesterday = now.minus({ days: 1 })
      this.$store.commit('insight/setDates', [yesterday.toFormat(dateFormat), yesterday.toFormat(dateFormat)])
      this.$store.commit('insight/setCurrentDateRange', { id: 'yesterday', name: 'Yesterday' })
    },
    fetchTrends (stopRefetch) {
      this.isFetchingTrends = true
      let params = {
        begin: this.beginDate,
        until: this.untilDate,
      }

      // Handle HQ vs regular company logic
      if (this.isHq) {
        if (this.selectedCompanies) {
          params.companies = this.selectedCompanies.map(c => c.id).join(',')
        } else {
          params.hq = this.company.id
        }
      } else {
        params.company = this.company.id
      }

      if (this.selectedProviders && this.selectedProviders.length > 0) {
        params.providers = this.selectedProviders.map(p => p.id).join(',')
      }
      this.$axios.get(`/trends/${this.company.slug}/inventories`, { params })
        .then(resp => {
          const data = resp.data
          this.trends = data
          this.isFetchingTrends = false
        })
        .catch(() => {
          if (!stopRefetch) {
            this.fetchTrends(true)
          } else {
            this.isFetchingTrends = false
          }
        })
    }
  }
}
</script>